// extracted by mini-css-extract-plugin
export var dropdown = "_vz-0";
export var imageWrapper = "_vz-3";
export var itemNameContainer = "_vz-1";
export var productImage = "_vz-2";
export var spinnerWrapper = "_vz-4";